module.exports = __webpack_public_path__ + "img/company_pic.94fd06a6.png";